import productModeration from './productModeration'
import productColombo from './productColombo'

export default {
	productModeration,
	productColombo
}
